import React, { useState } from 'react';
import logo from "../assets/Logo.png"
import '../Styles.css'
import { Link } from 'react-router-dom'
import Hamburger from "../components/Hamburger";
import { useAuth0 } from "@auth0/auth0-react";
import DropdownNav from './DropdownNav';

const Header = () => {
    const { user, isAuthenticated, loginWithRedirect } = useAuth0();
    const [showNavbar, setShowNavbar] = useState(false)

    const handleShowNavbar = () => {
        setShowNavbar(!showNavbar);
    };
    return (
        <nav className="navbar">
            <div className="container">
                <div className="logo">
                    <Link to="/"><img src={logo} className='logo-img' alt="#" /></Link>
                    <Link to="/" className='interncrafters'><h4>Intern Crafters</h4></Link>
                </div>
                <div className="menu-icon" onClick={handleShowNavbar}>
                    <Hamburger />
                </div>
                <div className={`nav-elements  ${showNavbar && "active"}`}>
                    <ul>
                        <li><button className="nav-items-btn" ><Link className="link-decor" to="/">Home</Link></button></li>
                        <li><button className="nav-items-btn" ><Link className="link-decor" to="/">About</Link></button></li>
                        <li><button className="nav-items-btn" ><Link className="link-decor" to="/">Internships</Link></button></li>
                        <li><button className="nav-items-btn" ><Link className="link-decor" to="/">FAQs</Link></button></li>
                        <li><button className="nav-items-btn" ><Link className="link-decor" to="/courses">Courses</Link></button></li>
                        {isAuthenticated ? <DropdownNav isHam={true} username={user.name} /> : <li><button className="nav-items-btn" onClick={() => loginWithRedirect()}>Log In</button></li>}
                    </ul>
                </div>
            </div>
        </nav>

    )
}

export default Header
